import React from "react";
import { IonCard, IonCardContent, IonButton, IonCheckbox } from "@ionic/react";

import { Controller, useForm } from "react-hook-form";
import { useMutation, useQuery } from "@apollo/client";
import { useHistory } from "react-router";
import toast from "react-hot-toast";

import { Breadcrumbs, Input } from "../../../components";

import { SET_PASSWORD_MUTATION } from "../../../graphql/mutations/auth.mutation";
import { GET_PRIVACY_POLICY } from "../../../graphql/queries/policy.query";

import "./login.styles.css";

const ResetPassword = () => {
  const history = useHistory();

  const [privacyPolicy, setPrivacyPolicy] = React.useState<any>();

  useQuery(GET_PRIVACY_POLICY, {
    variables: { type: "registration" },
    onCompleted(data) {
      const actualData = data.getPrivacyPolicy.data;
      if (actualData) setPrivacyPolicy(actualData);
    },
  });

  const [resetPasswordMutation] = useMutation(SET_PASSWORD_MUTATION, {
    onCompleted(data) {
      const resp = data.completeCustomerRegistration;
      if (resp.errors) {
        toast.error(resp.errors[0].message);
      } else {
        toast.success("Registrazione completata con successo!");
        history.push("/login");
      }
    },
    onError(error) {
      if (error.message) {
        toast.error(error.message);
      }
    },
  });

  const {
    handleSubmit,
    register,
    setValue,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      confirmPassword: "",
      acceptedTerms: false,
    },
  });

  const onFinish = (values: any) => {
    const resetToken = history?.location?.search;
    const urlParams = new URLSearchParams(resetToken);

    resetPasswordMutation({
      variables: {
        password: values.password,
        confirmPassword: values.confirmPassword,
        resetToken: urlParams.get("token"),
        acceptedTerms: values.acceptedTerms,
      },
    });
  };

  const breadcrumbEntries = [{ title: "Imposta la tua password" }];

  return (
    <div className="app-container">
      <Breadcrumbs items={breadcrumbEntries} />

      <div className="app-page-wrapper flex-center">
        <IonCard
          style={{
            width: "525px",
            padding: "20px",
          }}
        >
          <IonCardContent>
            <p
              className="card-title-text-large mb-default"
              style={{
                marginBottom: "20px",
              }}
            >
              Imposta la tua password
            </p>

            <form onSubmit={handleSubmit(onFinish)}>
              <Input
                name="Password"
                registerName="password"
                register={register}
                errors={errors}
                requiredMessage="Campo obbligatorio"
                pattern={{
                  value: /.{8,}/,
                  message: "La password deve essere lunga almeno 8 caratteri",
                }}
                type="password"
              />

              <Input
                name="Conferma password"
                registerName="confirmPassword"
                register={register}
                errors={errors}
                requiredMessage="Campo obbligatorio"
                validate={{
                  required: (values: any) =>
                    values === getValues("password") ||
                    "Le password non corrisponde",
                }}
                pattern={{
                  value: /.{8,}/,
                  message: "La password deve essere lunga almeno 8 caratteri",
                }}
                type="password"
              />
              <div
                style={{
                  display: "flex",
                }}
              >
                <div
                  style={{
                    paddingTop: "5px",
                  }}
                >
                  <Controller
                    name={`acceptedTerms`}
                    control={control}
                    rules={{
                      required: {
                        value: true,
                        message: "Devi accettare la privacy",
                      },
                    }}
                    render={({ field }) => {
                      return (
                        <IonCheckbox
                          color="primary"
                          slot="start"
                          checked={field.value}
                          onIonChange={(e) => {
                            setValue(`acceptedTerms`, e.detail.checked);
                          }}
                        />
                      );
                    }}
                  />
                </div>

                <div>
                  <div className="ms-default" style={{ fontSize: "14px" }}>
                    <div
                      dangerouslySetInnerHTML={{
                        __html: privacyPolicy?.footer?.replace(
                          /{{url}}/gi,
                          `${window.location.origin}/privacy-policy/registration`
                        ),
                      }}
                    />
                  </div>
                </div>
              </div>

              <div className="flex-justify-between">
                <span />

                <IonButton
                  shape="round"
                  slot="end"
                  size="default"
                  className="login-button"
                  type="submit"
                >
                  Invia
                </IonButton>
              </div>
            </form>
          </IonCardContent>
        </IonCard>
      </div>
    </div>
  );
};

export default ResetPassword;
